// extracted by mini-css-extract-plugin
export var button = "Button-module--button--b1113";
export var buttonDanger = "Button-module--buttonDanger--03f3d";
export var buttonDark = "Button-module--buttonDark--88074";
export var buttonFullWidth = "Button-module--buttonFullWidth--99b81";
export var buttonLight = "Button-module--buttonLight--71395";
export var buttonOutline = "Button-module--buttonOutline--02573";
export var buttonOutlineWithBorder = "Button-module--buttonOutlineWithBorder--5ed10";
export var buttonPrimary = "Button-module--buttonPrimary--fec52";
export var buttonSecondary = "Button-module--buttonSecondary--db745";